import {createElem} from 'common/util/dom';

import {PerfMeasure} from '../perf-measure';
import {reporter} from '../error-reporting';
import {featuresStore, FetchOption} from '../stores/features';
import {getProjectId, ironAppsInfo} from './index';
import {InitAppFunc, spaNavManager} from './spa-nav-manager';

/**
 * Attach an iron app to #mixpanel-application
 * @param initAppFunc - promise that returns iron app html element
 */
export async function attachApp(appName: string, initAppFunc: InitAppFunc) {
  if (!Object.prototype.hasOwnProperty.call(ironAppsInfo, appName)) {
    throw new Error(`Invalid iron app: ${appName}`);
  }

  const initMeasure = new PerfMeasure(`init-app`).start();
  const appContainer = document.getElementById(`mixpanel-application`);

  try {
    // iron apps heavily depend on using feature flags and gates to switch different functionality on initialization.
    // ideally we should never block UI shell on api requests, but this is a necessary evil for the time being
    // since we should not sacrifice correctness for performance.
    const featureStoreMeasure = new PerfMeasure(`await-features`).start();
    if (featuresStore.value === null) {
      await featuresStore.fetch({projectId: getProjectId()});
      featureStoreMeasure.end(featuresStore.value ? featuresStore.value.fetchSource : FetchOption.FetchFailed);
    } else {
      featureStoreMeasure.end(FetchOption.AlreadyPopulated);
    }

    spaNavManager.setInitAppFn(appName, initAppFunc);
    const appElem = initAppFunc();
    appContainer.innerHTML = ``;
    appContainer.appendChild(appElem);
  } catch (err) {
    appContainer.appendChild(createElem(`mp-alert`, {open: true, closeable: true}, err.toString()));
    reporter.error(err);
  }

  initMeasure.end();
}
